// src/components/PublicPageviewTracker.js
//
// Logt pageviews van bezoekers zonder account op de openbare pagina's.
// Ingelogde gebruikers worden al gelogd door DashboardLayout; die slaan we hier
// over, zodat hun cijfers niet veranderen en niets dubbel telt.
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/track';

// Alleen inhoudspagina's. Routes achter de inlog sturen een anonieme bezoeker
// door naar de homepage; zonder deze lijst zou ook dat tussenpad meetellen.
const PUBLIC_PREFIXES = ['/onderwerp/', '/voorbeeld/', '/info/', '/nieuws/', '/artikel/'];

function isPublicContentPath(pathname) {
  return pathname === '/' || PUBLIC_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

function hasJwt() {
  try {
    return !!localStorage.getItem('jwt');
  } catch {
    return false;
  }
}

export default function PublicPageviewTracker() {
  const location = useLocation();
  // React StrictMode draait effects in development twee keer; zonder deze ref
  // zou elke pagina dubbel tellen.
  const lastTracked = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastTracked.current === path) return;
    if (hasJwt() || !isPublicContentPath(location.pathname)) return;

    lastTracked.current = path;
    trackEvent({ type: 'pageview', path, title: document.title });
  }, [location.pathname, location.search]);

  return null;
}
